<script setup lang="ts">
import { twMerge } from 'tailwind-merge';
import { defineProps } from 'vue';

const props = defineProps<{
  class?: string;
}>();
</script>

<template>
  <div
    :class="
      twMerge(
        'flex rounded-16 bg-white px-m pb-m pt-l text-black dark:bg-gray-950 dark:text-white laptop:pb-[26px] laptop:pl-[40px] laptop:pr-[64px] laptop:pt-[26px]',
        props.class
      )
    "
  >
    <slot></slot>
  </div>
</template>
